export default __webpack_public_path__ + "static/media/kid-with-baloons.a6f2dd8e.jpg";